export default "__VITE_ASSET__D_ycO$dg__"